<template>
    <section class="features" id="features">
        <div class="container">
            <!-- Section Header -->
            <div class="section-header">
                <h2 class="section-title">Ключевые преимущества</h2>
                <h3 class="section-subtitle">
                    Разбираем задачи как <span>горячие</span> пирожки</h3>
            </div>
            <!-- End Section Header -->
            <!-- Section Content -->
            <div class="r1 row animateblock btt speed-1">
                <slick class="c1 col-md-12" id="features-carousel-1" :options="slickOptions">
                    <!-- Block 1 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon universal"><span class="icon_genius">
                            <Atom></Atom>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Универсально</h3>
                            <p class="description">
                                Гибкие возможности менять режимы отображения в зависимости от ваших целей. Доски, списки, таблицы, календари, диаграммы. Выбираете в пару кликов любой удобный вид для тех или иных работ.
                            </p>
                        </div>
                    </a>
                    <!-- End Block 1 -->
                    <!-- Block 2 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon fast"><span class="icon_map_alt">
                            <Racing></Racing>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Быстро</h3>
                            <p class="description">
                                Ускоряем работу с задачами в разы. Повышаем эффективность управления проектом. Вы тратите минимум времени на ведение проекта и максимум на сам проект.
                            </p>
                        </div>
                    </a>
                    <!-- End Block 2 -->
                    <!-- Block 3 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon visually"><span class="ion-android-globe">
                            <ReadingGlasses></ReadingGlasses>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Наглядно</h3>
                            <p class="description">
                                Всегда видна цельная картина по проекту. Кто чем занят, что сделано, что в работе, что в планах. Наглядные быстрые срезы по статусу любого проекта
                            </p>
                        </div>
                    </a>
                    <!-- End Block 3 -->
                    <!-- Block 4 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon multitasking"><span class="icon_gift_alt">
                            <Analytics></Analytics>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Многозадачность</h3>
                            <p class="description">
                                Возможность в несколько кликов создать сразу много задач на всю команду, независимо от того в каком виде и откуда вы получили задачи. Действия одновременно с несколькими задачами.
                            </p>
                        </div>
                    </a>
                    <!-- End Block 4 -->
                    <!-- Block 5 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon notifications"><span class="icon_genius">
                            <Chat></Chat>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Уведомления</h3>
                            <p class="description">
                                Продуманная политика уведомлений, широкие возможности настроек. Всё что нужно, чтобы уведомления не были назойливыми, а по-настоящему полезными и эффективными
                            </p>
                        </div>
                    </a>
                    <!-- End Block 5 -->
                    <!-- Block 6 -->
                    <a href="#" class="features-wrapper">
                        <div class="features-icon customization"><span class="icon_map_alt">
                            <Settings></Settings>
                        </span>
                        </div>
                        <div class="features-content">
                            <h3 class="title">Настраиваемость</h3>
                            <p class="description">
                                Огромное количество настроек системы под себя. Никто лучше вас не знает специфику вашей работы. Наша политика — не навязывать свои привычки, а сделать инструмент максимально подходящий под ваши процессы.
                            </p>
                        </div>
                    </a>
                    <!-- End Block 6 -->
                </slick>
            </div>
            <!-- End Section Content -->
        </div>
    </section>
</template>

<script>
    import Slick from 'vue-slick';
    import Atom from '@/assets/svg/atom.svg';
    import Racing from '@/assets/svg/racing.svg';
    import ReadingGlasses from '@/assets/svg/reading-glasses.svg';
    import Analytics from '@/assets/svg/analytics.svg';
    import Chat from '@/assets/svg/chat.svg';
    import Settings from '@/assets/svg/settings.svg';

    export default {
        name: "Advantages",
        components: {
            Slick,
            Atom,
            Racing,
            ReadingGlasses,
            Analytics,
            Chat,
            Settings
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                },
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Advantages.vue?84e2613c